import React, { createContext, useCallback, useEffect, useMemo, useState } from 'react';
// import { fetchTSVData } from '../lib/smallFunctions';
import { useNavigate } from 'react-router-dom';

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
    const [showPopup, setShowPopup] = useState(null);
    const [sheetsCarData, setSheetsCarData] = useState([])
    const [loadingSheetsData, setLoadingSheetsData] = useState(true)
    const [showCarDetails, setShowCarDetails] = useState(false)
    const [showBookNow, setShowBookNow] = useState(false)
    const [chosenCarIndex, setChosenCarIndex] = useState(null)
    const [categoryFilter, setCategoryFilter] = useState('all');
    const navigate = useNavigate();

    // --- MODAL VERSION ---
    // const handleClickCar = (index) => {
    //     setChosenCarIndex(index)
    //     setShowCarDetails(true)
    //     // if (!index) setChosenCarIndex(false)
    // }

    const formatCarNameForURL = useCallback((name) => {
        return name.toLowerCase().replace(/ /g, '_');
    }, []); // Empty dependency array: this function is fully stable

    const handleClickCar = useCallback((index, item) => {
        const formattedName = formatCarNameForURL(item.make + "_" + item.name + "_" + item.year_of_manufacture + "_" + item.color);
        // navigate is safe to omit from dependencies if it's from useNavigate, but added for safety
        // We include formatCarNameForURL to ensure it's the stable memoized version
        navigate(`/our_fleet/${item.id}/${formattedName}`);
    }, [navigate, formatCarNameForURL]); // Dependencies: navigate, formatCarNameForURL

    useEffect(() => {
        setLoadingSheetsData(true)
        // Fetch the TSV data from Google Sheets and set it in the state
        // fetchTSVData(setSheetsCarData)
        setLoadingSheetsData(false)
    }, [])

    const contextValue = useMemo(() => ({
        showPopup, setShowPopup,
        showCarDetails, setShowCarDetails,
        chosenCarIndex, setChosenCarIndex,

        // Memoized function
        handleClickCar,

        // Data and loading state
        sheetsCarData, setSheetsCarData,
        loadingSheetsData, setLoadingSheetsData,

        // Filter state
        categoryFilter, setCategoryFilter,
        showBookNow, setShowBookNow
    }), [
        showPopup, showCarDetails, chosenCarIndex, sheetsCarData,
        loadingSheetsData, categoryFilter, showBookNow, handleClickCar
        // State setters are stable by default (no need to list them)
    ]);


    return (
        <AppContext.Provider
            value={contextValue}
        >
            {children}
        </AppContext.Provider>
    );
};